import { AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoUserAttribute } from "amazon-cognito-identity-js";
// import generatePassword from 'password-generator';


// #TODO: MOVE THIS MAPPING TO CONFIG FILE
const { hostname } = window.location;
const parts = hostname.split('.');

const COGNITO_USER_POOL_MAPPING = {
  "prodBeta": "us-east-2_4vIGQ9swq",
  "devdb": "us-east-2_7S5W68CyP",
  "dev2": "us-east-2_ZCCclKcCi",
  "dev2db": "us-east-2_ZCCclKcCi",
  "uatdb": "us-east-2_qSPHVAXOz",
  "dashboard": "us-east-2_4vIGQ9swq"
}
const COGNITO_CLIENT_ID_MAPPING = {
  "prodBeta": "2ks0g19o5gfbetlkaeqlntnt8r",
  "devdb": "4o3m5orc2pl7sikr5hhv3r4n8g",
  "dev2": "4fkma3ten102smv3bse3equr8j",
  "dev2db": "4fkma3ten102smv3bse3equr8j",
  // "uatdb": "6e895sokg4bg5qcn7erhergm64"
  "uatdb": "3i2peh9bo2spbtaru56ucnm6af",
  "dashboard": "2ks0g19o5gfbetlkaeqlntnt8r"
}

// TODO: ADD BELOW CREDS IN CONFIG FILE
let cognitoConfig = {
  UserPoolId: COGNITO_USER_POOL_MAPPING.devdb,
  ClientId: COGNITO_CLIENT_ID_MAPPING.devdb,
};

if (parts.length > 2 && COGNITO_USER_POOL_MAPPING[parts[0]]) {
  // eslint-disable-next-line prefer-destructuring
  cognitoConfig = {
    UserPoolId: COGNITO_USER_POOL_MAPPING[parts[0]],
    ClientId: COGNITO_CLIENT_ID_MAPPING[parts[0]],
  };
}


const userPool = new CognitoUserPool(cognitoConfig);

const getUserData = (username: string) => {
  return {
    Username: username,
    Pool: userPool,
  };
};

export const signIn = async (username: string, password: string): Promise<CognitoUser> => {
  const authenticationData = {
    Username: username,
    Password: password,
  };

  const authenticationDetails = new AuthenticationDetails(authenticationData);
  const userData = getUserData(username);
  const cognitoUser = new CognitoUser(userData);
  return new Promise((resolve, reject) => {
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: () => {
        resolve(cognitoUser);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
};

export const signOut = async (username: string) => {
  const userData = getUserData(username);
  return new Promise((resolve, reject) => {
    const cognitoUserSignout = userPool.getCurrentUser();
    const cognitoUser = new CognitoUser(userData);
    if (cognitoUserSignout !== null) {
      cognitoUserSignout.signOut();
      resolve("Success: User Signed Out");
    }
    if (cognitoUser) {
      cognitoUser.signOut();
      resolve("Success: User Signed Out");
    }
    reject();
  });
};

export const signUp = async (first_name: string, last_name: string, email: string) => {
  const attributeList = [
    new CognitoUserAttribute({ Name: "email", Value: email }),
    // new CognitoUserAttribute({Name:"first_name",Value:first_name}),
    // new CognitoUserAttribute({Name:"last_name",Value:last_name}),
  ];
  // const password=generatePassword();
  const password = "qwertewegERTfew12@gfd"; // using random passwd for testing

  return new Promise((resolve, reject) => {
    userPool.signUp(email, password, attributeList, [], (err, result) => {
      if (err) {
        reject(err);
      } else {
        const cognitoUser = result?.user;
        resolve(cognitoUser);
      }
    });
  });
};

export const confirmSignUp = async (username: string, code: string) => {
  const userData = getUserData(username);
  const cognitoUser = new CognitoUser(userData);
  return new Promise((resolve, reject) => {
    cognitoUser.confirmRegistration(code, true, (err, result) => {
      if (err) {
        reject(err);
      } else {
        resolve(result);
      }
    });
  });
};

export const forgotPassword = async (username: string) => {
  const userData = getUserData(username);
  const cognitoUser = new CognitoUser(userData);
  return new Promise((resolve, reject) => {
    cognitoUser.forgotPassword({
      onSuccess: function () {
        resolve("Password reset inititated.Please check your email for further instruction.");
      },
      onFailure: function (err) {
        reject(err.message || JSON.stringify(err));
      },
    });
  });
};

export const resetPassword = async (username: string, confirmationCode: string, newPassword: string) => {
  const userData = getUserData(username);
  const cognitoUser = new CognitoUser(userData);
  return new Promise((resolve, reject) => {
    cognitoUser.confirmPassword(confirmationCode, newPassword, {
      onSuccess: function () {
        resolve("Password has been reset successfully.");
      },
      onFailure: function (err) {
        reject(err.message || JSON.stringify(err));
      },
    });
  });
};

export const verifyUser = async (username: string, accessToken: string) => {
  const userData = getUserData(username);
  const cognitoUser = new CognitoUser(userData);
  return new Promise((resolve, reject) => {
    cognitoUser.getSession((err, session) => {
      if (err) reject(err.message || JSON.stringify(err));
      const cognitoAccessToken = session.getAccessToken().jwtToken;
      cognitoAccessToken === accessToken ? 
      resolve("Token is valid")
      :
      reject("Invalid token")
    });
  });
};
